const RelationshipType = [
  { value: 1, name: 'Controlling Person', description: 'Controlling Person' }
];

export default RelationshipType;
